"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SinglePicture = void 0;
var _propTypes = require("prop-types");
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @param {string} src
 * @param {{'1x': string, '2x': string}} sizing
 * @returns {string}
 */
const createSrcSet = (src, sizing) => {
  return Object.entries(sizing).map(_ref => {
    let [key, value] = _ref;
    return "".concat(src, "?").concat(value, " ").concat(key);
  }).join(", ");
};
const transformDimensionToWidth = dimension => {
  const width = dimension.replace(/d=\d+x(\d+)/, (_, width) => width);
  return "w=" + width;
};
const SinglePicture = _ref2 => {
  let {
    src,
    alt,
    height,
    width,
    imageSizes: dimensionalSizes,
    breakpoints = {},
    dataCy
  } = _ref2;
  const imageSizes = (0, _react.useMemo)(() => {
    const sizing = Object.entries(dimensionalSizes);
    return Object.fromEntries(sizing.map(_ref3 => {
      let [key, x] = _ref3;
      return [key, Object.fromEntries(Object.entries(x).map(_ref4 => {
        let [xKey, dimension] = _ref4;
        return [xKey, transformDimensionToWidth(dimension)];
      }))];
    }));
  }, [dimensionalSizes]);
  const imageTagSrcSize = imageSizes.medium || imageSizes.large || imageSizes.small;
  return /*#__PURE__*/_react.default.createElement("picture", null, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, imageSizes.large && /*#__PURE__*/_react.default.createElement("source", {
    media: "(min-width: ".concat(breakpoints.large, ")"),
    srcSet: createSrcSet(src, imageSizes.large)
  }), imageSizes.medium && /*#__PURE__*/_react.default.createElement("source", {
    media: "(min-width: ".concat(breakpoints.medium, ")"),
    srcSet: createSrcSet(src, imageSizes.medium)
  }), /*#__PURE__*/_react.default.createElement("source", {
    srcSet: createSrcSet(src, imageSizes.small || imageSizes.medium || imageSizes.large)
  }), /*#__PURE__*/_react.default.createElement("img", {
    loading: "eager",
    src: "".concat(src, "?").concat(imageTagSrcSize["1x"]),
    srcSet: "".concat(src, "?").concat(imageTagSrcSize["2x"], " 2x"),
    width: width,
    alt: alt || "",
    "data-cy": dataCy,
    style: {
      width: "100%"
    }
  })));
};
exports.SinglePicture = SinglePicture;
SinglePicture.propTypes = {
  /** Array of objects like { src: 'pathToImage' } */
  src: _propTypes.PropTypes.string,
  /** Value for alt attribute */
  alt: _propTypes.PropTypes.string,
  /** initial width to use in query */
  width: _propTypes.PropTypes.number,
  /** sizes object for media breakpoints uploads */
  imageSizes: _propTypes.PropTypes.object,
  /** optional, breakpoints on which to apply imageSizes */
  breakpoints: _propTypes.PropTypes.object,
  /** for Cypress */
  dataCy: _propTypes.PropTypes.string
};